import React, { Component, Suspense } from "react";
import { Redirect } from "react-router";
import { replacestate } from "./../redux_store/actions/index";
import store from "./../redux_store/store/index";
import { withTranslation } from "react-multi-lang";
import { Silentauditobject, valiadateTenantPackage, Serviceforuserrights, Serviceforauditconfig, Servicecalls, ControlRights, SubMenuRightsonScreenViews, ControlRightsOnOrdersTask, Servicecallforuserrightscallback, getModuleRihtsOnModuleLoad } from "./../custom_functions/Functions.jsx";
import { defalutreduxState, isMultitenant, } from "./../custom_functions/Constance.jsx";
import Service from "./general/Service.jsx";
import $ from "jquery";
import "bootstrap";
import { withAlert } from "react-alert";
import IdleTimer from "react-idle-timer";
import { UserAgentApplication } from "msal";

const Changepassword = React.lazy(() => import("./user_management/modules/Changepassword"));
const Idlepop = React.lazy(() => import("./general/Idlepop.jsx"));
const Menu = React.lazy(() => import("./Menu.jsx"));
const UserDetails = React.lazy(() => import("./menu_Components/UserDetails.jsx"));

class Home extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      MenuGroup: "",
      ChildMenu: "",
      PageName: "",
      menuoption: 0,
      open: false,
      Menuselected: "",
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      UserNameValidcls: "",
      UserName:
        $.session.get("Username") !== undefined &&
          $.session.get("Username") !== ""
          ? $.session.get("Username")
          : "",
      PasswordValidcls: "",
      Password: "",
      seconds: 60,
      modalopen: false,
      ordercode: undefined,
      redirectTo:null
    };
    this.idleTimer = null;
    this.timerID = null;
    this.handleOnIdle = this.handleOnIdle.bind(this);
    this.handleOnAction = this.handleOnAction.bind(this);
    this.handleOnActive = this.handleOnActive.bind(this);
    this.onLoginClick = this.onLoginClick.bind(this);
    this.MainMeunClick = this.MainMeunClick.bind(this);
    this.ELNurl = window.appUrl.ELN;
  }

  componentWillUnmount() {
    this._isMounted = false;

    this.setupBeforeUnloadListener();
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.location.hash !== undefined && this.props.location.hash.length > 0) {
      let Sheetrun = this.props.location.hash.substring(2, this.props.location.hash.length - 1);
      if (Sheetrun !== undefined && Sheetrun.split(":").length > 1 && Sheetrun.split(":")[0] === "orderid") {
        let ordercode = Sheetrun.split(":")[1];
        this.setState({
          MenuGroup: "SheetView",
          PageName: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", { param: "", }),
          Menuselected: "SheetView_menu_group",
          ordercode: ordercode,
        });
      }
    }

    //this.onredirectrightsDidMount();
    this.getWorkflowdetails();

    this.setupBeforeUnloadListener();

    this.toCheckUserStatus();
  }

  toCheckUserStatus() {
    console.log(sessionStorage.User);
    Servicecalls(
      "" + this.ELNurl + "/User/GetUserActiveStatus",
      { usercode: parseInt(sessionStorage.User, 10) },
      (res) => {
        console.log(res);
      },
      (res) => {
        if (res.response && res.response.data) {
          try {
            const decoder = new TextDecoder("utf-8");
            const text = decoder.decode(res.response.data);
            console.log("Error response text:", text);
            let json;
            try {
              json = JSON.parse(text);
              if (json.status === 404 && json.message.includes("User not found with username")) {
                this.setState({
                  redirectTo:
                    isMultitenant === 0 ? "/" : "/#" + $.session.get("tenantdomain"),
                });
              }
              console.log("Error JSON:", json);
            } catch {
              console.log("Not JSON, raw text:", text);
            }
          } catch (err) {
            console.error("Failed to decode error response", err);
          }
        } else {
          console.error("Axios error:", res.message);
        }
      }
    );
  }

  getWorkflowdetails() {
    if ($.session.get("User") !== undefined && $.session.get("User") !== "") {
      // let passobject = {
      //   usercode: $.session.get("User"),
      //   lsusergroup: {
      //     usergroupcode: $.session.get("multiusergroups"),
      //     usergroupname: $.session.get("usergroupname")
      //   }
      // };

      // Servicecalls("" + this.ELNurl + "/Instrument/GetWorkflowanduseronUsercode",
      //   passobject, this.onGetWorkflowOnuserSuccess.bind(this),
      //   this.onGetWorkflowOnuserFailure.bind(this));

      let loggeduser = {
        usercode: $.session.get("User"),
        username: $.session.get("Username"),
        unifieduserid: $.session.get("unifieduserid"),
        dformat: $.session.get("ServerDateFormat"),
        lssitemaster: {
          sitecode: $.session.get("Usersite"),
          sitename: $.session.get("Usersitename"),
        },
        lsusergroup: {
          usergroupcode: $.session.get("multiusergroups"),
          usergroupname: $.session.get("usergroupname"),
          usergroupstatus: $.session.get("usergroupstatus"),
        },
        lsusergrouptrans: {
          usergroupcode: $.session.get("multiusergroups"),
          usergroupname: $.session.get("usergroupname"),
          usergroupstatus: $.session.get("usergroupstatus"),
        },
      };

      store.getState().Loggeduser = loggeduser;

      // let loggeduser;

      // loggeduser.usercode = $.session.get("User");
      // loggeduser.username = $.session.get("Username");
      // loggeduser.lssitemaster.sitecode = $.session.get("Usersite");
      // loggeduser.lssitemaster.sitename = $.session.get("Usersitename");
      // loggeduser.lsusergroup.usergroupname = $.session.get("usergroupname");
      // loggeduser.dformat = $.session.get("ServerDateFormat");
      // loggeduser.unifieduserid = $.session.get("unifieduserid");
      // loggeduser.multiusergroupcode = $.session.get("multiusergroups");

      // store.getState().Loggeduser = loggeduser;
    }
  }

  // onGetWorkflowOnuserSuccess(userdata) {
  //   store.getState().Loggeduser = userdata.user;
  //   store.getState().userworkflow = userdata.workflow;
  // }

  onGetWorkflowOnuserFailure(res) { }

  onUsernamechange(Value) {
    this.setState({ UserName: Value });
  }
  onUserPasswordchange(Value) {
    this.setState({ Password: Value });
  }
  handleOnAction(event) { }

  handleOnActive(event) { }

  handleOnIdle(event) {
    // let onprocess = store.getState().Sheetview.stopDisabled;
    // if (
    //   store.getState().Loggeduser.username !== "Administrator" &&
    //   !onprocess
    // ) {
    this.setState({ Password: "", modalopen: true });
    // }
  }

  onLoginClick(user, password) {
    let objdat = {};
    objdat["sUsername"] = this.state.UserName;
    objdat["sPassword"] = password;
    objdat["sDomainName"] = this.state.DomainCode;
    objdat["sCategories"] = this.state.DomainCategory;
    objdat["sSiteCode"] = user.lssitemaster.sitecode;
    objdat["logindate"] = new Date();
    objdat["objsilentaudit"] = Silentauditobject(
      "login",
      "Login",
      this.props.t("Login.IDS_AUDIT_LOGINUSER", { user: this.state.UserName })
    );
    objdat["multiusergroupcode"] = $.session.get("multiusergroups");

    Servicecalls(
      "" + this.ELNurl + "/Login/Login",
      objdat,
      this.onLoginSuccess.bind(this),
      this.onLoginFailure.bind(this)
    );

    // request
    //   .post("" + this.ELNurl + "/Login/Login")
    //   .send(objdat)
    //   .set({ 'Authorization': $.session.get("Token"), 'X-TenantID': $.session.get("tenantid"), Accept: 'application/json' })
    //   .then((res) => {
    //     this.onLoginSuccess(JSON.parse(res.text));
    //   }).catch((error) => {
    //     this.onLoginFailure(error);
    //   });
  }

  onLoginSuccess(response) {
    let loggeduser = response.user;
    if (loggeduser.objResponse.status) {
      $.session.set("User", loggeduser.usercode);
      $.session.set("Username", loggeduser.username);
      $.session.set("Usersite", loggeduser.lssitemaster.sitecode);
      $.session.set("Usersitename", loggeduser.lssitemaster.sitename);
      $.session.set("usergroupname", loggeduser.lsusergroup.usergroupname);


      store.getState().Loggeduser = loggeduser;
      // store.dispatch(updatecontrolrights(response.userrights));
      // store.dispatch(addauditoption(response.auditconfig));
      this.setState({
        modalopen: false,
      });

      Serviceforuserrights(
        "" +
        this.ELNurl +
        "/User/GetUserRightsonUser",
        {
          usercode: loggeduser.usercode,
          lsusergroup: {
            usergroupcode: response.multiusergroupcode,
            usergroupname: loggeduser.lsusergroup.usergroupname,
          },
        }
      );
      Serviceforauditconfig(
        "" +
        this.ELNurl +
        "/AuditTrail/GetAuditconfigUser",
        {
          usercode: loggeduser.usercode,
          lssitemaster: { sitecode: Number(sessionStorage.Usersite), sitename: sessionStorage.Usersitename },
          lsusergroup: { usergroupcode: response.multiusergroupcode },
        }
      );
    } else if (response.user.objResponse.information === "ID_NOTACTIVE") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_NOTACTIVE", { param: "" })
      );
    } else if (response.user.objResponse.information === "ID_GRPNOACT") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_GRPNOACT", { param: "" })
      );
    } else if (response.user.objResponse.information === "ID_INVALID") {
      this.props.alert.error(
        this.props.t("Header.IDS_MSG_INVALID", { param: "" })
      );
    } else if (response.user.objResponse.information === "IDS_MSG_NOTEXIST") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_NOTEXIST", { param: "" })
      );
    } else if (response.user.objResponse.information === "IDS_MSG_LOCKED") {
      this.props.alert.error(this.props.t("Login.IDS_MSG_LOCKED", { param: "" }));
    } else if (response.user.objResponse.information === "ID_EXPIRY") {
      this.props.alert.error(
        this.props.t("Login.IDS_MSG_EXPIRY", { param: "" })
      );
      let site = response.user.lssitemaster.sitecode;
      this.props.onforgot(site, this.state.UserName);
    }
  }
  onLoginFailure(response) { }

  onupdateuserSuccess(response) { }

  onupdateuserFailure(response) { }

  updateActiveuser(e) {
    if ($.session.get("User")) {
      let passObjDet = {
        sUserID: $.session.get("User"),
      };

      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/Login/UpdateActiveUser",
        ServiceHeaderobject: passObjDet,
        ServiceMethodType: "POST",
        ServcieonSuccess: this.onupdateuserSuccess.bind(this),
        ServcieonFailure: this.onupdateuserFailure.bind(this),
      });
    }
  }

  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", (ev) => {

      let passObjDet = {
        usercode: sessionStorage.getItem("User"),
        activeusercode: sessionStorage.getItem('activeUserId')
      };
      passObjDet.objsilentaudit = Silentauditobject("Logout", "logout",
        this.props.t("compareObjs.IDS_LOGOUTUSER", { user: sessionStorage.getItem("Username") })
      );

      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/Login/Logout",
        ServiceHeaderobject: passObjDet,
        ServiceMethodType: "POST",
        ServcieonSuccess: this.onlogoutSuccess.bind(this),
        ServcieonFailure: this.onlogoutFailure.bind(this),
      });
    });
  };

  MainMeunClick(Menu) {
    let PageName = "";
    let open = false;
    if (Menu === "SheetCreation") {
      PageName = this.props.t("Templates.Sheettemplates.IDS_LBL_SHEETCREATION", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetView") {
      PageName = this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetSetting") {
      /*else if (Menu === "TestMaster") {
      PageName = "Test Master";
    } */
      PageName = this.props.t("menu.IDS_SHEETSETTING", {
        param: "",
      });
    } else if (Menu === "AuditTrail") {
      PageName = this.props.t("Audittrail.Audittrailhistory.IDS_LBL_AUDITTRAIL", {
        param: "",
      });
      open = false;
    } else if (Menu === "UserManagement") {
      PageName = this.props.t("UserManagement.ID_USERMANAGEMENT", {
        param: "",
      });
      open = false;
    } else if (Menu === "Dashboard") {
      PageName = this.props.t("Dashboard.IDS_LBL_DASHBOARD", {
        param: "",
      });
      open = false;
    } else if (Menu === "Masters") {
      PageName = this.props.t("Masters.Taskmaster.IDS_LBL_MASTERS", {
        param: "",
      });
      open = false;
    } else if (Menu === "DownloadReport") {
      PageName = this.props.t("Reports.IDS_LBL_SCREENNAME", {
        param: "",
      });
      open = false;
    } else if (Menu === "Inventory") {
      PageName = this.props.t("Inventory", {
        param: "",
      });
      open = false;
    } else if (Menu === "LogBook") {
      PageName = this.props.t("LogBook", {
        param: "",
      });
      open = false;
    }

    this.setState({
      MenuGroup: Menu,
      PageName: PageName,
      open: open || true,
      Menuselected: "",
    });
  }

  ChilMenuclick(Menu) {
    this.setState({ ChildMenu: Menu });
  }

  onlogoutSuccess(response) {
    store.dispatch(replacestate(defalutreduxState));
    // setTimeout(() => {
    let tenantdomain = $.session.get("tenantdomain");
    if (tenantdomain !== undefined) {
      isMultitenant === 0 ? this.props.history.push("/") : this.props.history.push("/#" + tenantdomain);
    } else {
      this.props.history.push("/")
    }
    // }, 100);

    if ($.session.get("loggedfrom") !== undefined && $.session.get("loggedfrom") === "1") {
      var config = {
        auth: {
          authority: "https://login.microsoftonline.com/" + $.session.get("tenantdomain"),
          clientId: "62990499-6cde-4020-b0d3-97fbbe4b49f2",
          postLogoutRedirectUri: window.location.origin,
        },
        cache: { cacheLocation: "localStorage", },
        scopes: ["user.read"],
      };
      const userAgentApplication = new UserAgentApplication(config);
      userAgentApplication.logout($.session.get("azuretoken"));
    }
  }

  onlogoutFailure(response) { }

  onlogout(e) {
    if (this.ELNurl.trim() !== "") {
      let passObjDet = {
        usercode: sessionStorage.getItem("User"),
        activeusercode: sessionStorage.getItem('activeUserId')
      };
      passObjDet.objsilentaudit = Silentauditobject("Logout", "logout", this.props.t("compareObjs.IDS_LOGOUTUSER", { user: sessionStorage.getItem("Username") }));

      this.setState({ modalopen: false, });

      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/Login/Logout",
        ServiceHeaderobject: passObjDet,
        ServiceMethodType: "POST",
        ServcieonSuccess: this.onlogoutSuccess.bind(this),
        ServcieonFailure: this.onlogoutFailure.bind(this),
      });
    }
  }

  onlogoutonIdleTime(user) {
    if (this.ELNurl.trim() !== "") {

      let passObjDet = user;
      passObjDet.activeusercode = sessionStorage.getItem('activeUserId');
      passObjDet.objsilentaudit = Silentauditobject(
        "Logout",
        "logout",
        this.props.t("compareObjs.IDS_LOGOUTUSER", { user: this.state.UserName })
      );

      this.setState({
        modalopen: false,
      });

      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/Login/Logout",
        ServiceHeaderobject: passObjDet,
        ServiceMethodType: "POST",
        ServcieonSuccess: this.onlogoutSuccess.bind(this),
        ServcieonFailure: this.onlogoutFailure.bind(this),
      });
    }
  }

  OnChangepassword(e) {
    $("#onChangePassword").modal("show");
  }

  onprocess(pagename) {
    this.setState({ PageName: pagename });
  }

  onredirectrightsDidMount() {
    console.log(this._isMounted);
    console.log(store.getState().Menu?.Controlrights?.rights);
    if (!store.getState().Menu?.Controlrights?.rights && this._isMounted === true) {
      console.log("is refreshed")
      Servicecallforuserrightscallback("" + this.ELNurl + "/User/GetUserRightsonUser",
        {
          usercode: sessionStorage.User,
          lsusergroup: { usergroupcode: sessionStorage.multiusergroups },
        },
        () => this.onUserRightsUpdateSuccess()
      );
    }
  }

  onUserRightsUpdateSuccess() {

    let dashvisbile = false;
    let sheetvisbile = false;
    let shtcreationvisible = false;
    let basevisbile = false;
    let sheetstvisible = false;
    let usermanagementvisible = false;
    let audittrailvisible = false;
    let reportsvisible = false;
    let protoordervisible = false;
    let protocalsvisible = false;
    let parservisible = false;
    let logBookvisible = false;
    let inventoryvisible = false;
    let sequencevisible = false;

    dashvisbile = getModuleRihtsOnModuleLoad("IDS_MDL_DASHBOARD");
    sheetvisbile = getModuleRihtsOnModuleLoad("IDS_MDL_ORDERS");
    protoordervisible = getModuleRihtsOnModuleLoad("IDS_MDL_ORDERS");
    shtcreationvisible = getModuleRihtsOnModuleLoad("IDS_MDL_TEMPLATES");
    protocalsvisible = getModuleRihtsOnModuleLoad("IDS_MDL_TEMPLATES");
    usermanagementvisible = getModuleRihtsOnModuleLoad("IDS_MDL_SETUP");
    audittrailvisible = getModuleRihtsOnModuleLoad("IDS_MDL_AUDITTRAIL");
    reportsvisible = getModuleRihtsOnModuleLoad("IDS_MDL_REPORTS");
    logBookvisible = getModuleRihtsOnModuleLoad("IDS_MDL_LOGBOOK");
    inventoryvisible = getModuleRihtsOnModuleLoad("IDS_MDL_INVENTORY");
    sequencevisible = getModuleRihtsOnModuleLoad("IDS_MDL_SEQUENCEGENERATOR");
    let sheetcreationvisible = false;

    if (shtcreationvisible === false && protocalsvisible === false && sheetstvisible === false) {
      sheetcreationvisible = false;
    } else {
      sheetcreationvisible = true;
    }
    this.setState({
      Dashboard: dashvisbile,
      Sheetview: sheetvisbile,
      Sheetcreation: sheetcreationvisible,
      Basemaster: basevisbile,
      Sheetsetting: sheetstvisible,
      Usermanagement: usermanagementvisible,
      Audittrail: audittrailvisible,
      Report: reportsvisible,
      Protocols: protocalsvisible,
      ProtocolOrder: protoordervisible,
      Parser: parservisible,
      LogBook: logBookvisible,
      Inventory: inventoryvisible,
      Sequence: sequencevisible,
    }, () => {
      this.setScreenView({
        Dashboard: dashvisbile,
        Sheetview: sheetvisbile,
        Sheetcreation: sheetcreationvisible,
        Basemaster: basevisbile,
        Sheetsetting: sheetstvisible,
        Usermanagement: usermanagementvisible,
        Audittrail: audittrailvisible,
        Report: reportsvisible,
        Protocols: protocalsvisible,
        ProtocolOrder: protoordervisible,
        Parser: parservisible,
        LogBook: logBookvisible,
        Inventory: inventoryvisible,
        Sequence: sequencevisible,
      });
    });
  }

  onredirectrights(objrights) {
    if (!store.getState().Menu?.Controlrights?.rights) {
      Servicecallforuserrightscallback("" + this.ELNurl + "/User/GetUserRightsonUser",
        {
          usercode: sessionStorage.User,
          lsusergroup: { usergroupcode: sessionStorage.multiusergroups },
        },
        () => this.setScreenView(objrights)
      );
    } else {
      this.setScreenView(objrights);
    }
  }

  setScreenView(objrights) {
    let ordervisible = false;
    let sheetcreationvisible = false;

    if (objrights.Sheetview === false && objrights.ProtocolOrder === false) {
      ordervisible = (objrights.ProtocolOrder && objrights.ProtocolOrder === true) || (objrights.Sheetview && objrights.Sheetview === true) ? true : false;
      this.setState({
        sheetordervisible: false,
        Protocolordervisible: false,
      });
    } else {
      ordervisible = (objrights.ProtocolOrder && objrights.ProtocolOrder === true) || (objrights.Sheetview && objrights.Sheetview === true) ? true : false;
      this.setState({
        sheetordervisible: SubMenuRightsonScreenViews("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS"),
        Protocolordervisible: SubMenuRightsonScreenViews("IDS_MDL_ORDERS", "IDS_SCN_PROTOCOLORDERS"),
        Unlockordervisible: SubMenuRightsonScreenViews("IDS_MDL_ORDERS", "IDS_SCN_UNLOCKORDERS"),
      });
    }
    if (
      objrights.Sheetcreation === false &&
      objrights.Protocols === false &&
      objrights.Sheetsetting === false
    ) {
      this.setState({
        sheetordervisible: SubMenuRightsonScreenViews("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS"),
        Protocolordervisible: SubMenuRightsonScreenViews("IDS_MDL_ORDERS", "IDS_SCN_PROTOCOLORDERS"),
      });
      sheetcreationvisible = false;
    } else {
      sheetcreationvisible = true;
    }
    if (objrights.Dashboard === true) {
      this.setState({ MenuGroup: "Dashboard" });
    } else if (objrights.Dashboard === false && ordervisible === true) {

      this.setState({ MenuGroup: "SheetView" });

    } else if (
      objrights.Dashboard === false &&
      objrights.Sheetview === false &&
      sheetcreationvisible === true
    ) {
      this.setState({
        sheetcreationvisible: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATE"),
        Protocolcreationvisible: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE"),
        Sheetmapvisible: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_TEMPLATEMAPPING"),
      });
      this.setState({ MenuGroup: "SheetCreation" });
    }

    else if (
      objrights.Dashboard === false &&
      objrights.Sheetview === false &&
      objrights.Sheetcreation === false &&
      objrights.Basemaster === true
    ) {
      this.setState({
        TaskmasterVisible: SubMenuRightsonScreenViews("IDS_MDL_SETUP", "IDS_SCN_PROJECTMASTER"),
        ProjectmasterVisible: SubMenuRightsonScreenViews("IDS_MDL_SETUP", "IDS_SCN_PROJECTMASTER"),
        Samplemastervisible: SubMenuRightsonScreenViews("IDS_MDL_SETUP", "IDS_SCN_PROJECTMASTER"),


        logmastervisible: SubMenuRightsonScreenViews("IDS_MDL_LOGBOOK", "IDS_SCN_LOGBOOK")
      });
      this.setState({ MenuGroup: "Masters" });
    } else if (
      objrights.Dashboard === false &&
      objrights.Sheetview === false &&
      objrights.Sheetcreation === false &&
      objrights.Basemaster === false &&
      objrights.Sheetsetting === true
    ) {
      // this.setState({
      //   Sheetmapvisible: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_TEMPLATEMAPPING"),
      // });
      // this.setState({ MenuGroup: "SheetSetting" });
    } else if (
      objrights.Dashboard === false &&
      objrights.Sheetview === false &&
      objrights.Sheetcreation === false &&
      objrights.Basemaster === false &&
      objrights.Sheetsetting === false &&
      objrights.Usermanagement === true
    ) {
      let uMaster = ControlRights("IDS_MDL_SETUP", "IDS_SCN_USERMASTER");
      let uGroup = ControlRights("IDS_MDL_SETUP", "IDS_SCN_USERGROUP");
      let uRights = ControlRights("IDS_MDL_SETUP", "IDS_SCN_USERRIGHTS");
      let pTeam = ControlRights("IDS_MDL_SETUP", "IDS_SCN_PROJECTTEAM");
      let wFlow = ControlRights("IDS_MDL_SETUP", "IDS_SCN_ORDERWORKLOW");
      let pPolicy = ControlRights("IDS_MDL_SETUP", "IDS_SCN_PASSWORDPOLICY");
      let sFlow = ControlRights("IDS_MDL_SETUP", "IDS_SCN_TEMPLATEWORKFLOW");
      let domVis = ControlRights("IDS_MDL_SETUP", "IDS_SCN_DOMAIN");
      let actVis = ControlRights("IDS_MDL_SETUP", "IDS_SCN_ACTIVEUSER");
      let sitemaster = ControlRights("IDS_MDL_SETUP", "IDS_SCN_SITEMASTER");

      let pInstCategory = ControlRights("IDS_MDL_SETUP", "IDS_SCN_INSTRUMENTCATEGORY");
      let pMethodmaster = ControlRights("IDS_MDL_SETUP", "IDS_SCN_METHODMASTER");
      let pMethoddelimiters = ControlRights("IDS_MDL_SETUP", "IDS_SCN_METHODDELIMITER");
      let sDelimiters = ControlRights("IDS_MDL_SETUP", "IDS_SCN_DELIMITER");
      let Instrument = ControlRights("IDS_MDL_SETUP", "IDS_SCN_INSTRUMENTMASTER");

      this.setState({
        UserGroupVisible: isMultitenant === 2 ? false : uGroup.UserGroupRights.rights,
        UserMasterVisible: uMaster.UserGroupRights.rights,
        UserRightsVisible: isMultitenant === 2 ? false : uRights.UserGroupRights.rights,
        ProjectTeamVisible: pTeam.UserGroupRights.rights,
        WorkFlowVisible: wFlow.UserGroupRights.rights,
        PasswordPolicyVisible: pPolicy.UserGroupRights.rights,
        SheetWorkFlowVisible: sFlow.UserGroupRights.rights,
        DomainVisible: domVis.UserGroupRights.rights,
        ActiveVisible: actVis.UserGroupRights.rights,
        labelmastervisible: SubMenuRightsonScreenViews("IDS_MDL_SETUP", "IDS_SCN_BARCODEMASTER"),
        SitemasterVisible: isMultitenant === 2 ? false : sitemaster.UserGroupRights.rights,
        methodmasterVisible: pMethodmaster.UserGroupRights.rights,
        methoddelimitersVisible: pMethoddelimiters.UserGroupRights.rights,
        Delimitersvisible: sDelimiters.UserGroupRights.rights,
        Instrumentmastervisible: Instrument.UserGroupRights.rights,
        Instrumentcategoryvisible: pInstCategory.UserGroupRights.rights,
      });

      this.setState({ MenuGroup: "UserManagement" });
    } else if (
      objrights.Dashboard === false &&
      objrights.Sheetview === false &&
      objrights.Sheetcreation === false &&
      objrights.Basemaster === false &&
      objrights.Sheetsetting === false &&
      objrights.Usermanagement === false &&
      objrights.Audittrail === true
    ) {
      let auditrail = SubMenuRightsonScreenViews("IDS_MDL_AUDITTRAIL", "IDS_SCN_AUDITTRAILHIS");
      let cfrstgs = SubMenuRightsonScreenViews("IDS_MDL_AUDITTRAIL", "IDS_SCN_CFRSETTINGS");
      let auditconfig = SubMenuRightsonScreenViews("IDS_MDL_AUDITTRAIL", "IDS_SCN_AUDITTRAILCONFIG");
      this.setState({
        AudithistoryVisible: auditrail,
        CFRVisible: cfrstgs,
        AuditconfigVisible: auditconfig,
      });
      this.setState({ MenuGroup: "AuditTrail" });
    } else if (
      objrights.Dashboard === false &&
      objrights.Sheetview === false &&
      objrights.Sheetcreation === false &&
      objrights.Basemaster === false &&
      objrights.Sheetsetting === false &&
      objrights.Usermanagement === false &&
      objrights.Audittrail === false &&
      objrights.Report === true
    ) {
      let Reports = SubMenuRightsonScreenViews("IDS_MDL_REPORTS", "IDS_SCN_REPORTS");
      let saveAction = Reports;
      this.setState({
        saveAction,
        Reportviewer: SubMenuRightsonScreenViews("IDS_MDL_REPORTS", "IDS_SCN_REPORTVIEVER"),
        ReportTemplateMapping: SubMenuRightsonScreenViews("IDS_MDL_REPORTS", "IDS_SCN_REPORTMAPPER"),
      });
      this.setState({ MenuGroup: "DownloadReport" });
    } else if (
      objrights.Dashboard === false &&
      objrights.Sheetview === false &&
      objrights.Sheetcreation === false &&
      objrights.Basemaster === false &&
      objrights.Sheetsetting === false &&
      objrights.Usermanagement === false &&
      objrights.Audittrail === false &&
      objrights.Report === false &&
      objrights.Inventory === true
    ) {
      let sectionmaster = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_SECTIONMASTER");
      let unitmaster = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_UNITMASTER");
      let storage = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_STORAGELOCATION");
      let materialcategory = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_MATERIALCATEGORY");
      // let materialtype = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_MATERIALTYPE");
      let materialtype = SubMenuRightsonScreenViews("IDS_MDL_INVENTORY", "IDS_SCN_MATERIALTYPEPARAMS");
      let material = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_MATERIALMGMT");
      let materialinventory = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_MATERIALINVENTORY");
      let equType = SubMenuRightsonScreenViews("IDS_MDL_INVENTORY", "IDS_SCN_EQUIPMENT");
      let samTypevisible = ControlRights("IDS_MDL_INVENTORY", "IDS_TSK_SAMPLETYPE");
      let samCategoryvisible = ControlRights("IDS_MDL_INVENTORY", "IDS_TSK_SAMPLECAT");

      let supplier = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_SUPPLIER");
      let manufacturer = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_MANUFACTURER");
      let materialgrade = ControlRights("IDS_MDL_INVENTORY", "IDS_SCN_GRADEMASTER");

      this.setState({
        materialGradeVisible: materialgrade.UserGroupRights.rights,
        manfacVisible: manufacturer.UserGroupRights.rights,
        supplierVisible: supplier.UserGroupRights.rights,

        samTypevisible: samTypevisible.UserGroupRights.rights,
        samCategoryvisible: samCategoryvisible.UserGroupRights.rights,
        materialTypeVisible: materialtype,//.UserGroupRights.rights,
        sectionmastervisible: sectionmaster.UserGroupRights.rights,
        unitmastervisible: unitmaster.UserGroupRights.rights,
        storagevisible: storage.UserGroupRights.rights,
        materialvisible: material.UserGroupRights.rights,
        materialinventoryvisible: materialinventory.UserGroupRights.rights,
        materialcategoryvisible: materialcategory.UserGroupRights.rights,
        equTypeVisible: equType,
        samplevisible: SubMenuRightsonScreenViews("IDS_MDL_INVENTORY", "IDS_SCN_SAMPLEMGMT"),
        equMasterVisible: SubMenuRightsonScreenViews("IDS_MDL_INVENTORY", "IDS_TSK_EQUIPMENTMASTER"),
        equCategoryVisible: SubMenuRightsonScreenViews("IDS_MDL_INVENTORY", "IDS_SCN_EQUIPMENTCATEGORY"),
      })
      this.setState({ MenuGroup: "Inventory" });
    } else if (
      objrights.Dashboard === false &&
      objrights.Sheetview === false &&
      objrights.Sheetcreation === false &&
      objrights.Basemaster === false &&
      objrights.Sheetsetting === false &&
      objrights.Usermanagement === false &&
      objrights.Audittrail === false &&
      objrights.Report === false &&
      objrights.Inventory === false &&
      objrights.LogBook === true
    ) {
      let logbook = SubMenuRightsonScreenViews("IDS_MDL_LOGBOOK", "IDS_SCN_LOGBOOK");
      this.setState({
        logbookvisible: logbook,
      })
      this.setState({ MenuGroup: "LogBook" });
    }

    // else if (
    //   objrights.Dashboard === false &&
    //   objrights.Sheetview === false &&
    //   objrights.Sheetcreation === false &&
    //   objrights.Basemaster === false &&
    //   objrights.Sheetsetting === false &&
    //   objrights.Usermanagement === false &&
    //   objrights.Audittrail === false &&
    //   objrights.Report === false &&
    //   objrights.Parser === false &&
    //   objrights.LogBook === true
    // ) {
    //   let Log = ControlRights("IDS_MDL_LOGBOOK", "IDS_SCN_LOGBOOK");
    //   let logbookvisible = Log.UserGroupRights.rights;
    //   this.setState({
    //     logbookvisible

    //   });
    //   this.setState({ MenuGroup: "LogBook" });

    // }
  }

  redirecttohome() {
    // isMultitenant === 0 ? this.props.history.push("/") : this.props.history.push("/#" + $.session.get("tenantdomain"));
    window.location.reload(false);
  }

  render() {
    var plantype = valiadateTenantPackage();

    if (!$.session.get("User")) {
      setTimeout(() => {
        let tenantdomain = $.session.get("tenantdomain");
        if (this.props && this.props.history) {
          if (tenantdomain !== undefined) {
            isMultitenant === 0
              ? this.props.history.push("/")
              : this.props.history.push("/#" + tenantdomain);

          } else {
            this.props.history.push("/")
          }
        }

      }, 100);
      return <div></div>;
    }

    else if (this.state.MenuGroup === "Dashboard") {
      this.sheetcontent = (
        <Redirect to={{ pathname: "/dashboard", state: {} }} />
      );
    }

    else if (this.state.MenuGroup === "SheetView") {
      if (this.state.sheetordervisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/registertask", state: {} }} />
        );
      }
      else if (this.state.Protocolordervisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/Protocolorder", state: {} }} />
        );
      }
      //unlock order
      else if (this.state.Unlockordervisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/unlockorder", state: {} }} />);
      }
    }
    if (this.state.MenuGroup === "SheetCreation") {
      if (this.state.sheetcreationvisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/sheetcreation", state: {} }} />
        );
      }
      else if (this.state.Protocolcreationvisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/protocols", state: {} }} />
        );
      }
      // mapping
      else if (this.state.Sheetmapvisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/sheetmapping", state: {} }} />
        );
      }
    }
    // else if (this.state.MenuGroup === "SheetSetting") {
    //   if (this.state.Sheetmapvisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/sheetmapping", state: {} }} />
    //     );
    //   }
    // }
    // else if (this.state.MenuGroup === "Masters") {
    //   if (this.state.TaskmasterVisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/testmaster", state: {} }} />);
    //   }
    //   else if (this.state.ProjectmasterVisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/projectmaster", state: {} }} />);
    //   }
    //   else if (this.state.Samplemastervisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/samplemaster", state: {} }} />);
    //   }
    //   else if (this.state.Instrumentmastervisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/inventory", state: {} }} />);
    //   }
    //   else if (this.state.Unlockordervisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/unlockorder", state: {} }} />);
    //   }
    //   else if (this.state.logmastervisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/logbook", state: {} }} />);
    //   }
    // }
    else if (this.state.MenuGroup === "Inventory") {
      // new on below
      // inventory screen
      if (this.state.materialvisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/material", state: {} }} />
        );
      } else if (this.state.samplevisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/sample", state: {} }} />
        );
      }
      // inv parameters supscreens
      else if (this.state.materialTypeVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/materialtype", state: {} }} />);
      } else if (this.state.materialcategoryvisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/materialcategory", state: {} }} />
        );
      } else if (this.state.samTypevisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/sampletype", state: {} }} />
        );
      } else if (this.state.samCategoryvisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/samplecategory", state: {} }} />
        );
      } else if (this.state.storagevisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/storagelocation", state: {} }} />
        );
      } else if (this.state.unitmastervisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/unitmaster", state: {} }} />
        );
      } else if (this.state.materialGradeVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/materialgrade", state: {} }} />
        );
      } else if (this.state.supplierVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/supplier", state: {} }} />
        );
      } else if (this.state.manfacVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/manufacturer", state: {} }} />
        );
      }

      //Equipment
      else if (this.state.equMasterVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/instrumentsmaster", state: {} }} />
        );
      }//Equipment parameters
      else if (this.state.equTypeVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/instrumentstype", state: {} }} />
        );
      } else if (this.state.equCategoryVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/instrumentscategory", state: {} }} />
        );
      }
    }
    else if (this.state.MenuGroup === "LogBook") {
      if (this.state.logbookvisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/logbook", state: {} }} />);
      }
    }
    else if (this.state.MenuGroup === "DownloadReport") {
      if (this.state.saveAction === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/reportdesigner", state: {} }} />);
      }
      //viewer
      else if (this.state.Reportviewer === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/reportviewer", state: {} }} />);
      }
      // report mapper
      else if (this.state.ReportTemplateMapping === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/reportMapping", state: {} }} />);
      }
    }
    else if (this.state.MenuGroup === "UserManagement") {
      //site only admin
      if ((isMultitenant === 1 && "3" === plantype && (sessionStorage?.multiusergroups === "1")) || isMultitenant === 0 && (sessionStorage?.multiusergroups === "1")) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/Usersite", state: {} }} />);
      }
      //User Mgmt
      else if (this.state.UserGroupVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/Usergroup", state: {} }} />);
      }
      else if (this.state.UserMasterVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/Usermaster", state: {} }} />);
      }
      else if (this.state.UserRightsVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/Userrights", state: {} }} />);
      }
      //Project Mgmt
      else if (this.state.ProjectTeamVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/Projectteam", state: {} }} />);
      } else if (this.state.ProjectmasterVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/projectmaster", state: {} }} />);
      } else if (this.state.TaskmasterVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/testmaster", state: {} }} />);
      }
      //Workflow Mgmt
      else if (this.state.SheetWorkFlowVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/Sheetworkflow", state: {} }} />);
      } else if (this.state.WorkFlowVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/Orderworkflow", state: {} }} />);
      }

      //Active user, domain and Passwordpolicy only admin
      else if (sessionStorage?.multiusergroups === "1") {
        this.sheetcontent = (<Redirect to={{ pathname: "/activeuser", state: {} }} />);
      }
      else if (sessionStorage?.multiusergroups === "1") {
        this.sheetcontent = (<Redirect to={{ pathname: "/domain", state: {} }} />);
        // } else if (this.state.PasswordPolicyVisible === true) {
      } else if (sessionStorage?.multiusergroups === "1") {
        this.sheetcontent = (<Redirect to={{ pathname: "/Passwordpolicy", state: {} }} />);
      }

      //parser
      else if (this.state.Instrumentmastervisible === true && isMultitenant === 0) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/instruments", state: {} }} />);
      }
      else if (this.state.Delimitersvisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/delimiters", state: {} }} />);
      }
      else if (this.state.methoddelimitersVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/methoddelimiters", state: {} }} />);
      }
      else if (this.state.methodmasterVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/methodmaster", state: {} }} />);
      }
      // else if (this.state.Samplemastervisible === true) {
      //   this.sheetcontent = (
      //     <Redirect to={{ pathname: "/samplemaster", state: {} }} />);
      // }
      //barcode
      else if (this.state.labelmastervisible === true) {
        this.sheetcontent = (<Redirect to={{ pathname: "/labelmaster", state: {} }} />);
      }
      else if (plantype === "2" && isMultitenant !== 2 && sessionStorage?.multiusergroups === "1") {
        this.sheetcontent = (<Redirect to={{ pathname: "/sequencegenerator", state: {} }} />);
      }
    }
    else if (this.state.MenuGroup === "AuditTrail") {
      if (this.state.AudithistoryVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/audithistory", state: {} }} />
        );
      }
      else if (this.state.CFRVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/cfrsettings", state: {} }} />
        );
      }
      else if (this.state.AuditconfigVisible === true) {
        this.sheetcontent = (
          <Redirect to={{ pathname: "/auditconfiguration", state: {} }} />
        );
      }
    }
        if (this.state.redirectTo !== undefined && this.state.redirectTo !== null) {
          return <Redirect to={this.state.redirectTo} />;
        }
    // else if (this.state.MenuGroup === "LogBook") {
    //   if (this.state.logbookvisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/logbook", state: {} }} />);
    //   }
    // else if (this.state.MenuGroup === "Methodsetup") {
    //   // if (this.state.Instrumentmastervisible === true) {
    //   //   this.sheetcontent = (
    //   //     <Redirect to={{ pathname: "/instruments", state: {} }} />);
    //   // }
    //   // else if (this.state.Instrumentcategoryvisible === true) {
    //   //   this.sheetcontent = (
    //   //     <Redirect to={{ pathname: "/instrumentcategory", state: {} }} />);
    //   // }else 
    //   if (this.state.Delimitersvisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/delimiters", state: {} }} />);
    //   }
    //   else if (this.state.methoddelimitersVisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/methoddelimiters", state: {} }} />);
    //   }
    //   else if (this.state.methodmasterVisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/methodmaster", state: {} }} />);
    //   }
    // }

    // else if (this.state.MenuGroup === "Methodsetup") {
    //   this.sheetcontent = (
    //     <Redirect to={{ pathname: "/sdmsmappedinstruments", state: {} }} />);
    // } else if (this.state.MenuGroup === "LogBook") {

    //   if (this.state.logbookvisible === true) {
    //     this.sheetcontent = (
    //       <Redirect to={{ pathname: "/logbook", state: {} }} />);
    //   }
    // }



    return (


      <div id="idElnBody" style={{ height: "100vh" }}>

        <Suspense fallback={<div></div>}>
          <Menu
            sendData={this.MainMeunClick}
            childmenuclick={this.ChilMenuclick.bind(this)}
            selected={this.state.Menuselected}
            menugroup={this.state.MenuGroup}
            redirectrights={this.onredirectrights.bind(this)}
          />
        </Suspense>
        <div id="bodycontent" className="d-flex flex-column">

          <Service
            Tourl={this.state.ServiceToUrl}
            MethodType={this.state.ServiceMethodType}
            onSuccess={this.state.ServcieonSuccess}
            onFailure={this.state.ServcieonFailure}
            Headerobject={this.state.ServiceHeaderobject}
            onReseturl={() => {
              this.setState({ ServiceToUrl: "" });
            }}
          ></Service>
          <div
            id="top-menu-item-container"
            className="navbar static-top topmenuitem cls-top-menu-item-container"
          >
            <span className="clsPageName">{this.state.PageName}</span>
            <div id="topmenuitem" className="topmenuitem">
              {
                <Suspense fallback={<div></div>}>
                  <UserDetails
                    onlogout={this.onlogout.bind(this)}
                    OnChangepassword={this.OnChangepassword.bind(this)}
                    redirecttohome={this.redirecttohome.bind(this)}
                  />
                </Suspense>}
              {/* <UserMaster onlogout={this.onlogout.bind(this)} /> */}
            </div>
          </div>


          {this.sheetcontent !== undefined ? this.sheetcontent :
            this._isMounted ? <div className="container">
              <div className="row">
                <div className="col align-self-center">
                  <div>
                    <div className="text-center">
                      <div className="imagealign">
                        <img src="./images/Nouserrights/NoUserRights.png" alt="" height="250" />
                      </div>
                      <div className="textwrapalign">
                        <h1>User rights not provided to display Please contact Administrator</h1>
                        <ul className="list-unstyled">
                          <li className="norights">
                            User rights management is a security feature for controlling user access to tasks that would normally
                          </li>
                          <li className="norights">
                            be restricted to the root role. By applying security attributes, or rights, to processes and to users, the
                          </li>
                          <li className="norights">
                            site can divide super user privileges among several administrators.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div>
                  </div>
                </div>

              </div>
            </div> : <div></div>}


        </div>
        <div>
          <Suspense fallback={<div></div>}>
            <Changepassword
              onlogout={this.onlogout.bind(this)}
            />
          </Suspense>
          <Suspense fallback={<div></div>}>
            <Idlepop
              Isopen={this.state.modalopen}
              onLogout={this.onlogoutonIdleTime.bind(this)}
              onLogin={this.onLoginClick.bind(this)}
            />
          </Suspense>
          <IdleTimer
            ref={(ref) => { this.idleTimer = ref; }}
            timeout={1000 * 60 * 15}
            onActive={this.handleOnActive}
            onIdle={this.handleOnIdle}
            onAction={this.handleOnAction}
            debounce={250}
            element={document.body}
          />
        </div>
      </div>
    );
  }
}

export default withAlert()(withTranslation(Home));
